module.exports = __webpack_public_path__ + "static/media/vodacom.2ce4a0bf.png";